/* eslint-disable */
import React, { forwardRef } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import FiatBrand from '~/components/FiatBrand/FiatBrand';
import css from './PaperClip.scss';

export const ALIGN_LEFT = 'left';
export const ALIGN_CENTER = 'center';
export const ALIGN_RIGHT = 'right';

const classes = {
	root: css.paperClip,
	isLeft: css.isLeft,
	isRight: css.isRight,
	isCenter: css.isCenter,
};

const propTypes = {
	...FiatBrand.propTypes,
	align: PropTypes.oneOf([ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT]),
};

const defaultProps = {
	...FiatBrand.defaultProps,
	classes,
	stripes: '#ffb80f',
	align: 'left',
};

export const PaperClip = forwardRef(({
	className,
	classes,
	align,
	...props
}, ref) => {
	return (
		<FiatBrand
			ref={ref}
			{...props}
			className={cls(classes.root, className, {
				[classes.isLeft]: align === ALIGN_LEFT,
				[classes.isCenter]: align === ALIGN_CENTER,
				[classes.isRight]: align === ALIGN_RIGHT,
			})}
		/>
	);
});

PaperClip.ALIGN_LEFT = ALIGN_LEFT;
PaperClip.ALIGN_CENTER = ALIGN_CENTER;
PaperClip.ALIGN_RIGHT = ALIGN_RIGHT;
PaperClip.displayName = 'PaperClip';
PaperClip.propTypes = propTypes;
PaperClip.defaultProps = defaultProps;
export default PaperClip;
